import { PopupMenu } from './PopupMenu';
import { isPrintableCharacter, keyCode } from './helpers';

export class MenuItem {
    constructor(domNode, menuObj) {
        this.domNode = domNode;
        this.menu = menuObj;
        this.popupMenu = null;
        this.isMenubarItem = false;
        this.navMenuDelay = 300;
        this.keyCode = keyCode;
    }

    init() {
        this.domNode.tabIndex = -1;

        this.domNode.addEventListener('keydown', this.handleKeydown.bind(this));
        this.domNode.addEventListener('click', this.handleClick.bind(this));
        this.domNode.addEventListener('focus', this.handleFocus.bind(this));
        this.domNode.addEventListener('blur', this.handleBlur.bind(this));
        this.domNode.addEventListener('mouseover', this.handleMouseover.bind(this));
        this.domNode.addEventListener('mouseout', this.handleMouseout.bind(this));

        // Initialize flyout menu

        let nextElement = this.domNode.nextElementSibling;

        if (nextElement && nextElement.tagName === 'UL') {
            this.popupMenu = new PopupMenu(nextElement, this);
            this.popupMenu.init();
        }
    }

    isExpanded() {
        return this.domNode.getAttribute('aria-expanded') === 'true';
    }

    handleKeydown(event) {
        let currentTarget = event.currentTarget,
            char = event.key,
            isMenuOpen = false,
            clickEvent;

        switch (event.keyCode) {
            case this.keyCode.SPACE:
            case this.keyCode.RETURN:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToFirstItem();
                } else {
                    // Create simulated mouse event to mimic the behavior of ATs
                    // and let the event handler handleClick do the housekeeping.
                    try {
                        clickEvent = new MouseEvent('click', {
                            view: window,
                            bubbles: true,
                            cancelable: true,
                        });
                    } catch (err) {
                        if (document.createEvent) {
                            // DOM Level 3 for IE 9+
                            clickEvent = document.createEvent('MouseEvents');
                            clickEvent.initEvent('click', true, true);
                        }
                    }
                    currentTarget.dispatchEvent(clickEvent);
                }

                isMenuOpen = true;
                break;

            case this.keyCode.UP:
                this.menu.setFocusToPreviousItem(this);
                isMenuOpen = true;
                break;

            case this.keyCode.DOWN:
                this.menu.setFocusToNextItem(this);
                isMenuOpen = true;
                break;

            case this.keyCode.LEFT:
                this.menu.setFocusToController('previous', true);
                this.menu.close(true);
                isMenuOpen = true;
                break;

            case this.keyCode.RIGHT:
                if (this.popupMenu) {
                    this.popupMenu.open();
                    this.popupMenu.setFocusToFirstItem();
                } else {
                    this.menu.setFocusToController('next', true);
                    this.menu.close(true);
                }
                isMenuOpen = true;
                break;

            case this.keyCode.HOME:
            case this.keyCode.PAGEUP:
                this.menu.setFocusToFirstItem();
                isMenuOpen = true;
                break;

            case this.keyCode.END:
            case this.keyCode.PAGEDOWN:
                this.menu.setFocusToLastItem();
                isMenuOpen = true;
                break;

            case this.keyCode.ESC:
                this.menu.setFocusToController();
                this.menu.close(true);
                isMenuOpen = true;
                break;

            case this.keyCode.TAB:
                this.menu.setFocusToController();
                break;

            default:
                if (isPrintableCharacter(char)) {
                    this.menu.setFocusByFirstCharacter(this, char);
                    isMenuOpen = true;
                }
                break;
        }

        if (isMenuOpen) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    setExpanded(value) {
        this.domNode.setAttribute('aria-expanded', value ? 'true' : 'false');
    }

    handleClick() {
        this.menu.setFocusToController();
        this.menu.close(true);
    }

    handleFocus() {
        this.menu.hasFocus = true;
    }

    handleBlur() {
        this.menu.hasFocus = false;
        setTimeout(this.menu.close.bind(this.menu, false), this.navMenuDelay);
    }

    handleMouseover() {
        this.menu.hasHover = true;
        this.menu.open();
        if (this.popupMenu) {
            this.popupMenu.hasHover = true;
            this.popupMenu.open();
        }
    }

    handleMouseout() {
        if (this.popupMenu) {
            this.popupMenu.hasHover = false;
            this.popupMenu.close(true);
        }

        this.menu.hasHover = false;
        setTimeout(this.menu.close.bind(this.menu, false), this.navMenuDelay);
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/organisms/header/scripts/a11y-navigation/MenuItem.js